import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import PageHeader from '../components/PageHeader';
import AnimatedSection from '../components/AnimatedSection';
import SEO from '../components/SEO';
import Majors from '../components/Majors'; // Komponen ini digunakan ulang untuk menampilkan kartu
import '../components/styles.css'; // Menggunakan stylesheet komponen umum

const PengembanganAkademikPage = () => {
  const [facilities, setFacilities] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchFacilities = async () => {
      setLoading(true);
      try {
        const q = query(collection(db, 'academicFacilities'), orderBy('order', 'asc'));
        const querySnapshot = await getDocs(q);
        const facilitiesData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
        setFacilities(facilitiesData);
      } catch (error) {
        console.error("Error fetching academic facilities data: ", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFacilities();
  }, []);

  return (
    <>
      <SEO 
        title="Fasilitas Pengembangan Akademik - SMK Pariwisata Sumbangsih"
        description="Jelajahi fasilitas penunjang akademik modern kami seperti laboratorium komputer, laboratorium bahasa, dan perpustakaan untuk mendukung proses belajar."
      />
      <PageHeader 
        title="Fasilitas Pengembangan Akademik" 
        subtitle="Kami menyediakan beragam fasilitas modern untuk mendukung proses belajar mengajar." 
      />
      <AnimatedSection>
        <Majors majors={facilities} loading={loading} showTitle={false} />
      </AnimatedSection>
    </>
  );
};

export default PengembanganAkademikPage;